import { useState, useEffect } from 'react'

import infoIcon from '../components/images/info-icon-orange.svg'
import { formatMoney } from 'services/util'

import themeCss from './sass/theme.module.scss'
import cardCss from '../auctions/sass/auctionscards.module.scss'
import css from './sass/bidmodal.module.scss'

export default function ConfirmFixedItemModal( { item, showFixedItemModal, setShowFixedItemModal, 
  purchaseResponse, setPurchaseResponse, auctionDetail, 
  purchaseQuantity, submitFn } ) {  

  const [failedPurchase, setFailedPurchase] = useState(false)
  const [success, setSuccess] = useState(false)
  const [userAmountPurchased, setUserAmountPurchased] = useState()

  //TO DO fix this for purchaseFixedItem
  useEffect(() => {
    //if there is an error from bid response, set failed bid to true to show the front end notify updates
    // update the loaded bid to the new bid amount 
    if (purchaseResponse?.error) {
      setFailedPurchase(true)
      setPurchaseResponse(undefined)
    }
    //if modal is showing
    if (showFixedItemModal) {

      //check to see if the purchase was successful
      if (purchaseResponse?.FixedItemId === item.FixedItemId) {
        setSuccess(true)
      }
    }
    
  }, [purchaseResponse])

  useEffect(() => {

    if (success) {
      const thisItem = auctionDetail.FixedItems.find(ele => ele.FixedItemId === item.FixedItemId)
      setUserAmountPurchased(thisItem.MyAmountPurchased)
    }

  }, [auctionDetail, success])
  
  const closeSuccessfulPurchaseModal = () => {
    if (success) {
      //reset purchase response to undefined to return to original state
      setPurchaseResponse(undefined)
      //remove successful state of donation
      setSuccess(false)
      // hide the modal
      setShowFixedItemModal(false)
    }
  }

  if (success) {
    return (
      <div className={css['bid-modal-container']}>
      <div className={themeCss['modal-background']} onClick={ () =>  closeSuccessfulPurchaseModal() }></div>

      <div className={`${css['bid-modal-content']} ${themeCss['box-top-yellow-accent-wide']}`}>
        
        <p className={css['bid-modal-content-title']}>Thanks for your purchase!</p>
        <p>You have purchased a total of {formatMoney(userAmountPurchased)} × {item.Title}!</p>

        <div className={css['bid-modal-actions']} >
  
          <div onClick={ () => closeSuccessfulPurchaseModal() }>
            <p className={css['bid-modal-cancel']}>
              Continue
            </p>
          </div>
        </div>
      </div>
    </div>
    )
  }



  //use effect for when the amount available changes
  // useEffect(() => {
  //   // TO DO - need to account for when the amount available changes
  //   console.log('hello something changed')
  //   const updatedItem = auctionDetail?.Items.find((check) => check.ItemId === item.ItemId)


  // }, [auctionDetail, initialBid])

  const itemPluralText = (amount, additional) => {
    const addWord = additional && item.MyAmountPurchased > 0

    if (amount > 1) return `${formatMoney(amount)} ${addWord ? 'additional ' : ''}items`
    if (amount === 1) return `${formatMoney(amount)} ${addWord ? 'additional ' : ''}item`
  }

  return (
    <div className={css['bid-modal-container']}>
      <div className={themeCss['modal-background']} onClick={() => { setShowFixedItemModal(false) }}></div>

      <div className={`${css['bid-modal-content']} ${themeCss['box-top-yellow-accent-wide']}`}>
        {failedPurchase ? 
          <div className={css['bid-modal-failed-header']}>
            <img className={css['bid-modal-info-icon']} src={infoIcon} alt='Information' />
            <p className={css['bid-modal-content-header']}>Quantity available has changed</p>
          </div> :
          <p className={css['bid-modal-content-header']}>Confirm Purchase</p>
        }
        <p className={css['bid-modal-content-title']}>{item?.Title}</p>
        
        {failedPurchase ? 
          <p className={css['purchase-modal-content-text']}>Please click cancel purchase and try again with a new quantity.</p> :
          <div>
            <p className={css['purchase-modal-content-text']}>Are you sure you want to purchase {itemPluralText(purchaseQuantity, true)} for ${formatMoney(purchaseQuantity * item.PurchasePrice)}?</p>
            {item.MyAmountPurchased > 0 && <div className={css['purchase-modal-quantity-info']}>
              <p>
                You currently have purchased {itemPluralText(item.MyAmountPurchased)} for ${formatMoney(item.MyAmountPurchased * item.PurchasePrice)}</p>
              <p>
                This would bring your new quantity to {itemPluralText(item.MyAmountPurchased + purchaseQuantity)} for ${formatMoney((item.MyAmountPurchased + purchaseQuantity) * item.PurchasePrice)}</p>
            </div>}
          </div>
        }
        
        <div className={css['bid-modal-actions']} >
            <button disabled={failedPurchase} className={`${themeCss['FilledBlue']} ${themeCss['button']}`} onClick={()=>submitFn(item, purchaseQuantity)}>
              Confirm Purchase
            </button>

          <div onClick={() => { setShowFixedItemModal(false) }}>
            <p className={css['bid-modal-cancel']}>
              Cancel Purchase
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}